import { render } from "./MobileConsumptionRecords.vue?vue&type=template&id=6922125d&scoped=true"
import script from "./MobileConsumptionRecords.vue?vue&type=script&lang=js"
export * from "./MobileConsumptionRecords.vue?vue&type=script&lang=js"

import "./MobileConsumptionRecords.vue?vue&type=style&index=0&id=6922125d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6922125d"],['__file',"src/views/mobile/account_center/components/MobileConsumptionRecords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6922125d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6922125d', __exports__)) {
    api.reload('6922125d', __exports__)
  }
  
  module.hot.accept("./MobileConsumptionRecords.vue?vue&type=template&id=6922125d&scoped=true", () => {
    api.rerender('6922125d', render)
  })

}


export default __exports__